import { gql } from "@apollo/client";

export default gql`
  fragment ComplianceProgramListItem on ComplianceProgramNode {
    id
    title
    created
    updated
    dueDate
    startDate
    ongoing
    periodStartDate
    periodEndDate
    startDateOffset
    startDateDueDateOffset
    startDatePeriodStartOffset
    startDatePeriodEndOffset
    state
    recurrence
    creator {
      id
      name
      email
      avatar
    }
    requiredTopicTemplates {
      edges {
        node {
          id
          title
        }
      }
    }
    canUpdate {
      permission
    }
    canDelete {
      permission
    }
    performanceAssessmentTemplate {
      id
      assessmentType
      anonymity
      providers
      delivery
    }
    managerAssessmentTemplate {
      id
      assessmentType
      anonymity
      providers
      delivery
    }
    peerAssessmentTemplate {
      id
      assessmentType
      anonymity
      providers
      delivery
    }
    engagementSurveyTemplate {
      id
      assessmentType
      anonymity
      providers
      delivery
    }
    appliesTo
    appliesToTeams {
      edges {
        node {
          id
          title
        }
      }
    }
    appliesToManagers {
      edges {
        node {
          id
          name
          avatar
        }
      }
    }
    appliesToUsers {
      edges {
        node {
          id
          name
          avatar
        }
      }
    }
    excludedHireDateAfter
    excludedUsers {
      edges {
        node {
          id
          name
          avatar
        }
      }
    }
  }
  query getCompliancePrograms(
    $applicableUser: Int
    $organizationId: Int!
    $state: ComplianceProgramState
    $state_In: [ComplianceProgramState]
    $assessmentType: AssessmentType
    $search: String
    $after: String
    $dueDateGte: Date
    $dueDateLte: Date
  ) {
    detailedCompliancePrograms(
      applicableUser: $applicableUser
      organizationId: $organizationId
      state: $state
      state_In: $state_In
      search: $search
      assessmentType: $assessmentType
      orderBy: "state,-due_date"
      first: 10
      after: $after
      dueDate_Gte: $dueDateGte
      dueDate_Lte: $dueDateLte
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...ComplianceProgramListItem
        }
      }
    }
  }
`;
